import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Login.css';

export default class Login extends Component {
  static propTypes = {
    userInfo: PropTypes.object,
    actions: PropTypes.object,
    userStatus: PropTypes.string,
  }

  constructor(props) {
    super(props);
    if (props.userInfo) {
      const { login, password } = props.userInfo;
      this.state = {
        login: login || '',
        password: password || '',
      };
    }
  }

  state = { login: '', password: '' }

  componentWillReceiveProps(nextProps) {
    if (this.props.userInfo !== nextProps.userInfo) {
      this.updateInputs(nextProps);
    }
  }

  handleSubmitClick = () => {
    this.props.actions.userLogin(this.state.login, this.state.password);
  }

  handleLoginChange = event => {
    this.setState({ ...this.state, login: event.target.value });
    this.props.actions.resetLogin();
  }

  handlePasswordChange = event => {
    this.setState({ ...this.state, password: event.target.value });
    this.props.actions.resetLogin();
  }

  updateInputs = nextProps => {
    const { login, password } = nextProps.userInfo;
    if (login && password) {
      this.setState({ login, password });
    }
  }

  render() {
    const { userStatus } = this.props;
    const forbidden = userStatus === 'USER_FORBIDDEN' ? ' forbidden' : '';
    return (
      <div className="Login">
        <div className="wrapper">
          <div className="header_lk">
            <div className="lk">
              <div className="h2_lk">РЕКЛАМА - ПРОДВИГАЕТ</div>
              <div className="logo_lk">
                <a href="https://ads-market.ru/">ads-market.ru</a>
              </div>
            </div>
          </div>
          <div className="main_lk">
            <div className="lk">
              <div id="login">
                <form name="form-login" autoComplete="on">
                  <div className="h3_lk">Вход в личный кабинет</div>
                  <div className={`line${forbidden}`}>
                    <p className="fontawesome-warning-sign" />
                    Неверный логин или пароль
                  </div>
                  <div className="padding">
                    <span className="fontawesome-user" />
                    <input
                      id="user"
                      type="text"
                      placeholder="Логин"
                      value={this.state.login}
                      onChange={this.handleLoginChange}
                    />
                    <div className="clearfix" />
                    <span className="fontawesome-lock" />
                    <input
                      id="pass"
                      type="password"
                      placeholder="Пароль"
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                    />
                    <input type="button" value="Войти" onClick={this.handleSubmitClick} />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="footer_lk">
            <div className="lk">
              <div className="phone">
                <p className="fontawesome-phone" />
                <a href="tel:88126276776">+7 812 <b>627 67 76</b></a>
              </div>
              <div className="mail">
                <p className="fontawesome-envelope" />
                <a href="mailto:info@ads-market.ru" className="mail">info@ads-market.ru</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx